import _ from "lodash";

const useFirstMedicalDocument = _.first;

export default useFirstMedicalDocument;